export const sumOfMeters = (data, attr) => {
    let sumOfMeters = 0;
    data.map(obj => {
        sumOfMeters = sumOfMeters + obj[attr];
    });
    return sumOfMeters;
}